(function (document, window, $) {
  'use strict';

  var Site = window.Site;

  $(document).ready(function ($) {
    Site.run();
    var alertify_defaults = {
      type: "alert",
      delay: 5000,
      theme: 'bootstrap'
    };

    alertify.theme(alertify_defaults.theme);

    $('.server-message').each(function () {
      var message = $(this).html();
      var type = $(this).data('type');
        if (type=="warning") type = 'error';
        inMessage(message, {type:type});
    })

  });

  var alertify_defaults = {
    type: "alert",
    delay: 5000,
    theme: 'bootstrap'
  };

  window.inConfirm = function (message, callBackOk, callBackNot) {

    alertify.theme(alertify_defaults.theme);
    // confirm dialog
    alertify.confirm(message, function () {
      // user clicked "ok"
    }, function () {
      // user clicked "cancel"
    });
  };

  var message_defaults = {
    "type": "info",
    "title": "",
    "closeButton": true,
    //"positionClass": "toast-top-full-width",
    "showMethod": "slideDown",
    "hideMethod": "slideUp",
    "timeOut": "10000",
    "extendedTimeOut": "1000",
  };

    window.errorsCheck = function (data) {
        if (data.errors != undefined){
            window.inMessageError(data.errors);
        }
    };

  window.errorFields = function (errorFields) {
    if (errorFields != undefined){
      for (let i = 0; i < errorFields.length; i++) {
        var target = errorFields[i];
        $('[name="'+target+'"]').closest('.form-group').addClass('has-error');
      }
    }
  };

  window.inMessageError = function (message) {
   if (message.constructor === Array){
       for (var m in message) inMessage(message[m], {type: 'error'});
       return
   }

    inMessage(message, {type: 'error'});
  };

  window.inMessage = function (message, options) {
    var options = $.extend(true, {}, message_defaults, options);

    var title = options.title;
    var type = options.type || "info";
    //var type = "error";

    switch (type) {
      case "success":
        toastr.success(message, title, options);
        break;
      case "warning":
        toastr.warning(message, title, options);
        break;
      case "error":
        toastr.error(message, title, options);
        break;
      case "info":
        toastr.info(message, title, options);
        break;
      default:
        toastr.info(message, title, options);
    }
  }

  window.inErrorMessage = function (message, title) {
    inMessage(message, title, {type: "error"});
  }

})(document, window, jQuery);
